<template>
  <qx-card title="列表">
    <el-dialog :visible.sync="dialogVisible" title="附件查看">
      <section class="imgPreiewBox">
        <uploadFile
            :fileList="fileList"
            accept="image/*"
            fileType="img"
            :disabled="true"
            :limit="fileList.length"
          />
      </section>
    </el-dialog>
    <LogRightDialog ref="logRightDialog" busiCode="imp100041" />
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'cardNo'">
                  <span
                    v-if="
                      scope.row.paymentWay === 1 || scope.row.paymentWay === 3
                    "
                    >{{ scope.row.cardNo }}</span
                  >
                  <span v-else-if="scope.row.paymentWay === 4">{{
                    scope.row.oilProductName
                  }}</span>
                  <span v-else>--</span>
                </section>
                <!-- 附件 -->
                <section
                  v-if="scope.column.property === 'file'"
                  @click="showFile(scope.row)"
                >
                  <span class="primary cur">查看</span>
                </section>
                <!-- 附件 end -->
                <!-- 线路名称 -->
                <section
                  v-if="scope.column.property === 'sourceName'"
                  @click="toLineDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <!-- 线路名称 end -->
                <!-- 车牌号 -->
                <section
                  v-if="scope.column.property === 'plateNumber'"
                  @click="toCarDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <!-- 车牌号 end -->
                <!-- 司机姓名 -->
                <section
                  v-if="scope.column.property === 'carDriverMan'"
                  @click="toDriverDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <!-- 司机姓名 end -->
                <section
                  v-if="
                    scope.column.property !== 'cardNo' &&
                    scope.column.property !== 'file' &&
                    scope.column.property !== 'sourceName' &&
                    scope.column.property !== 'plateNumber' &&
                    scope.column.property !== 'carDriverMan'
                  "
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import uploadFile from '@qx/components/uploadFile/uploadFile'; // 上传文件
import {
  repostCostDetailList,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    TableSetting,
    uploadFile,
  },
  data () {
    return {
      dialogImageUrl: '', // 弹窗图片地址
      dialogVisible: false, // 弹窗显示状态
      fileList: [], // 附件集合
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'orderId', label: '订单号', fixed: true },
          { prop: 'createTime', label: '上报时间' },
          { prop: 'amountDouble', label: '消费金额' },
          { prop: 'tableTypeName', label: '上报费用类型' },
          { prop: 'paymentWayName', label: '支付方式' },
          { prop: 'cardNo', label: '卡号/油站' },
          { prop: 'oilMileageDouble', label: '加油公里数' },
          { prop: 'priceUnitDouble', label: '单价' },
          { prop: 'consumeNum', label: '数量' },
          { prop: 'file', label: '附件' },
          { prop: 'remark', label: '备注' },
          { prop: 'dependTime', label: '发车时间' },
          { prop: 'sourceName', label: '线路名称' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'carDriverMan', label: '司机姓名' },
          { prop: 'carDriverPhone', label: '司机手机号' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: repostCostDetailList,
    toLineDetail (item) {
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.sourceId}`,
        full: true,
      });
    },
    toCarDetail (item) {
      this.jump({
        label: `查看车辆${item.plateNumber ? ('-' + item.plateNumber) : ''}`,
        url: `/manage/car/archives/my/detailRecord?plateNumber=${encodeURIComponent(item.plateNumber)}`,
        full: true,
      });
    },
    toDriverDetail (item) {
      this.jump({
        label: '司机详情',
        url: `/manage/archives/driver/archives/detail?id=${item.carDriverId}`,
        full: true,
      });
    },
    showFile (item) {
      this.fileList = [];
      for (const key in item) {
        if (key.startsWith('fileUrl') && item[key] && item[key].length > 0) {
          this.fileList.push({url: item[key]});
        }
      }
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
.imgPreiewBox {
  padding-bottom: 24px;
}
</style>
